import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages } from "@fortawesome/free-solid-svg-icons";
import "./LaUne.css";
import { ImageHelper } from "../gallery/ImageHelper";

import quote from "./images/quote.png";
import { Painting } from "../gallery/painting";
import { Environment } from "../../environments/environment";

interface LaUneProps {
  paintings: Painting[];
}

function LaUne(props: LaUneProps) {
  const [orientedLink, setOrientedLink] = useState<string>("/tableaux-l");
  const [srcSet, setSrcSet] = useState<string>("");

  const baseUrl = Environment.getBaseUrl();
  const defaultImageUrl = `${baseUrl}/img_expos/blue1.webp`;

  useEffect(() => {
    if (window.innerHeight > window.innerWidth) {
      setOrientedLink("/tableaux-h");
    }
    const homePainting =
      props.paintings[ImageHelper.dayNumber() % props.paintings.length];
    setSrcSet(ImageHelper.createSrcSetWithOrientation(homePainting));
  }, [props.paintings]);

  return (
    <main className="jumbotron p-0 p-md-3 home rounded-0 bg-transparent">
      <div className="container bg-transparent">
        <picture>
          <source
            srcSet={srcSet}
            sizes="(max-width: 1536px) 100vw, 1536px"
            type="image/webp"
          />
          <img
            src={defaultImageUrl}
            className="rounded img-fluid img-home"
            alt="default"
          />
        </picture>
      </div>
      <div className="card-body bg-transparent ny-quote mt-4">
        <table>
          <tbody>
            <tr>
              <td className="ny-quote-margin"></td>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className="ny-quote-text-container">
                        <p className="card-text citation-titre ps-3">
                          &laquo; Peindre, peindre, toujours peindre, encore
                          peindre, le mieux possible, le vide et le plein, le
                          léger et le dense, le vivant et le
                          souffle.&nbsp;&raquo;
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p className="card-text citation-auteur ps-3">
                          &mdash; Zao Wou-Ki
                        </p>
                      </td>
                      <td>
                        <img
                          src={quote}
                          alt="quote"
                          className="ny-quote-img"
                          width="40em"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="d-block d-sm-none">
          <p className="mt-3 mb-0 pb-0 text-center">
            <a
              href={orientedLink}
              className="btn btn-outline-primary waves-effect"
              role="button"
            >
              <FontAwesomeIcon icon={faImages} className="me-1" />
              Voir les tableaux
            </a>
          </p>
        </div>
        <div className="d-none d-sm-block">
          <p className="mt-3 mb-0 pb-0 text-center">
            <a
              href={orientedLink}
              className="btn btn-outline-primary waves-effect btn-lg"
              role="button"
            >
              <FontAwesomeIcon icon={faImages} className="me-1" />
              Voir les tableaux
            </a>
          </p>
        </div>
      </div>
    </main>
  );
}

export default LaUne;
